import { createFileRoute, redirect } from '@tanstack/react-router';

import { FormDetailsPage } from '@/features/form-details/FormDetailsPage';
import { useAuthStore } from '@/shared/stores/authStore';

export const Route = createFileRoute('/admin/form-details')({
  beforeLoad: () => {
    // Form details use `system_settings` (SUPER_ADMIN only). Guard at the route
    // so a non-super admin can't reach it by URL (the API also rejects).
    const state = useAuthStore.getState();
    if (state.user?.adminRole !== 'SUPER_ADMIN') {
      // eslint-disable-next-line @typescript-eslint/only-throw-error -- TanStack Router contract: beforeLoad throws a redirect object.
      throw redirect({ to: '/admin' });
    }
  },
  component: FormDetailsPage,
});
